import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItemCard,
  FormLabel,
} from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';

interface FormSwitchFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  description?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

export const FormSwitchField = <TFieldValues extends FieldValues>({
  control,
  name,
  label,
  description,
  disabled,
  className,
}: FormSwitchFieldProps<TFieldValues>) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItemCard className={className}>
        <div className="space-y-0.5">
          <FormLabel>{label}</FormLabel>
          {description && <FormDescription>{description}</FormDescription>}
        </div>
        <FormControl>
          <Switch checked={!!field.value} onCheckedChange={field.onChange} disabled={disabled} />
        </FormControl>
      </FormItemCard>
    )}
  />
);
FormSwitchField.displayName = 'FormSwitchField';
